import { useQuery } from '@tanstack/react-query';
import { fetchProductAddOnGroups } from '../services/productAddonGroups';

export const productAddOnGroupKeys = {
    list: (productId: string) => ['smr-admin', 'product-addon-groups', productId] as const,
};

export function useProductAddOnGroupsQuery(productId: string | undefined) {
    return useQuery({
        queryKey: productAddOnGroupKeys.list(productId ?? ''),
        queryFn: () => fetchProductAddOnGroups(productId!),
        enabled: !!productId,
    });
}
